import React from 'react';
import PropTypes from 'prop-types';

const EditorMention = (props) => {
  const { children, decoratedText } = props;
  // Replace brackets with spaces to save text length
  const preparedText = decoratedText.replace('[', ' ').replace(']', ' ');

  // Clone child elements to replace text with brackets
  return (
    <span className="editor-input-mention">
      {children.map((child) =>
        React.cloneElement(child, {
          text: preparedText,
        }),
      )}
    </span>
  );
};

export default EditorMention;

EditorMention.propTypes = {
  children: PropTypes.node,
  decoratedText: PropTypes.string,
};
